import { KeyboardArrowUp } from "@material-ui/icons";
import { KeyboardEvent } from "react";
import { useScrollTop } from "src/itsf/hook/useScrollTop";
import "./scrollTop.scss";

export const ScrollTopButton = () => {
    const { scrollTop, scrollPosition } = useScrollTop();

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            scrollTop();
        }
    };

    return (
        <div
            className="scrollTop"
            role="button"
            style={{ display: `${scrollPosition > 200 ? "inline" : "none"}` }}
            tabIndex={0}
            onClick={scrollTop}
            onKeyDown={handleKeyDown}
        >
            <KeyboardArrowUp />
        </div>
    );
};
